import { Typography } from "components/parts/Typography/Typography";
import styled from "styled-components";
import { Star } from "@styled-icons/bootstrap/Star";
import { StarFill } from "@styled-icons/bootstrap/StarFill";
import { newColors } from "constants/newColors";
import { StyledTbodyTd } from "components/templates/Table/styled";

export const StyledNoDataTypography = styled(Typography)`
  position: relative;
  top: 1rem;
  left: 1rem;
`;

export const StyledStar = styled(Star)`
  color: ${newColors.primary};
  width: 60%;
  cursor: pointer;
`;

export const StyledStarFill = styled(StarFill)`
  color: ${newColors.primary};
  width: 60%;
  cursor: pointer;
`;

export const StyledMemoWrapper = styled.div`
  width: 210px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const StyledMarkedTbodyTd = styled(StyledTbodyTd)`
  transition-duration: 0.2s;
  :hover {
    background: ${newColors.white};
    opacity: 0.8;
  }
`;
